import { render, staticRenderFns } from "./AdministrationAddDatumDialog.vue?vue&type=template&id=89d03604"
import script from "./AdministrationAddDatumDialog.vue?vue&type=script&lang=js"
export * from "./AdministrationAddDatumDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports